import { ContentBlock, ContentState, genKey } from 'draft-js'
import { stateToHTML } from 'draft-js-export-html'
import { stateFromHTML } from 'draft-js-import-html'
import { getLoomDataFromLink } from '../../../utils/loom'
import { Map } from 'immutable'
import { VIDEO_PLACEHOLDER_CLASS } from '../Loom/EmbeddedVideo'

const stateToHTMLVideoOptions = {
  blockRenderers: {
    atomic: (block) => {
      const src = block.getData().get('src')
      if (!src) return null
      const ratio = block.getData().get('ratio')
      return ( 
        `<div
          class=${VIDEO_PLACEHOLDER_CLASS}
          data-src=${src}
          ${ratio && `data-ratio=${ratio}`}
        >&nbsp;</div>`
      )
    }
  }
}

const stateFromHTMLVideoOptions = {
  customBlockFn: element => {
    if (element.className === VIDEO_PLACEHOLDER_CLASS) {
      return {
        type: 'atomic',
        data: { ...element.dataset }
      }
    }
    return null
  }
}

export const contentToHTMLWithVideo = state => stateToHTML(state, stateToHTMLVideoOptions)
export const contentFromHTMLWithVideo = html => stateFromHTML(html, stateFromHTMLVideoOptions)


export const contentToPlaintextWithVideo = (currentContent, clean) => {
  let text = ''
  for (const block of currentContent.getBlocksAsArray()) {
    if (block.getType() === 'atomic') {
      text += `${block.getData().get('src')} r:${block.getData().get('ratio')}\n`
    } else {
      text += block.getText() + '\n'
    }
  }
  return clean ? text.trim() : text
}

export const contentFromPlaintextWithVideo = text => {
  const blocks = []
  for (const line of text.split('\n')) {
    const loomData = getLoomDataFromLink(line)
    if (loomData) {
      blocks.push(new ContentBlock({
        key: genKey(),
        type: 'atomic',
        text: ' ',
        data: Map(loomData)
      }))
    } else {
      blocks.push(new ContentBlock({
        key: genKey(),
        type: 'unstyled',
        text: line
      }))
    }
  }
  return ContentState.createFromBlockArray(blocks)
}
